<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-2/3 md:w-1/3"
    zIndex="100001"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">
      Ambil Nomor Surat
    </section>

    <!-- Body -->
    <div class="w-full p-5">
      <div class="w-full flex items-end mb-5">
        <div class="flex-1">
          <label for="" class="flex mb-1">Nomor Urut</label>
          <vs-input
            class="w-full"
            disabled="true"
            placeholder="Nomor belum diambil"
            v-model="input.angka"
          ></vs-input>
        </div>
        <div class="px-2">
          <vs-button
            icon-pack="feather"
            icon="icon-search"
            class="mt-2 "
            :disabled="isLoading"
            @click="searchNumber"
            >Cari</vs-button
          >
        </div>
      </div>
      <div class="w-full mb-5">
        <label for="" class="flex mb-1">Nomor Surat</label>
        <vs-input class="w-full" v-model="input.nomor"></vs-input>
        <small class="text-grey">* Nomor ini akan muncul pada surat</small>
      </div>
      <div class="w-full mb-5">
        <label for="" class="flex mb-1">Tanggal</label>
        <global-input-date v-model="input.tanggal"></global-input-date>
      </div>
    </div>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          :disabled="!canSubmit"
          @click="handleOnSubmit"
        >
          Simpan
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Batal
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import { digofHttp as axios } from "@/axios";
import moment from "moment";
export default {
  props: {
    suratId: {
      type: [Number, String],
      required: true
    },
    kodeSurat: {
      type: Object,
      required: true
    },
    suratUuid: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      dialog: {
        isActive: false
      },
      isLoading: false,
      canSubmit: false,
      input: {
        nomor: null,
        angka: null,
        tipe: "surat_keluar",
        tanggal: moment(new Date()).format("YYYY-MM-DD")
      }
    };
  },
  watch: {
    "input.tanggal"() {
      this.setNomor();
    }
  },
  methods: {
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
    async searchNumber() {
      this.input.angka = await this.fetchNumber();
      this.setNomor();
      this.canSubmit = true;
    },
    async fetchNumber() {
      try {
        this.isLoading = true;
        const response = await axios({
          method: "get",
          url: `surat-keluar/get-number`,
          headers: {
            Authorization: `Bearer ${this.$sanctum.getToken()}`
          }
        });
        this.isLoading = false;
        return response.data.data.number;
      } catch (error) {
        this.isLoading = false;
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Terjadi kesalahan, silakan coba lagi"
        });
        return null;
      }
    },
    setNomor() {
      const year = moment(this.input.tanggal).format("YYYY");
      this.input.nomor = `${this.kodeSurat.kode_surat}/${this.input.angka}/DPMPTSP/${year}`;
    },
    async handleOnSubmit() {
      await this.sumbitNomorSurat();
    },
    async sumbitNomorSurat() {
      const inputData = {
        surat_id: this.suratId,
        kode_surat: this.kodeSurat.kode_surat,
        ...this.input
      };

      try {
        this.$vs.loading();

        await axios({
          method: "post",
          url: `surat-keluar/set-number/${this.suratUuid}`,
          data: inputData,
          headers: {
            Authorization: `Bearer ${this.$sanctum.getToken()}`
          }
        });

        this.$vs.notify({
          type: "success",
          title: "Sukses",
          text: "Berhasil mengambil nomor surat"
        });

        this.$emit("submitCallback");

        this.toggleActive(false);
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Terjadi kesalahan, silakan coba lagi"
        });
      }
      this.$vs.loading.close();
    },
    handleOnCancel() {
      this.toggleActive(false);
    }
  }
};
</script>
